if (!customElements.get('quick-add-to-cart-button')) {
  class TG_QuickAddToCartButton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.delegateElement = new themegoal.libs.Delegate(this);

      this.delegateElement.on(
        'click',
        '[data-action="quick-add-to-cart"]',
        this._addToCart.bind(this)
      );
    }

    disconnectedCallback() {
      if (this.delegateElement) {
        this.delegateElement.destroy();
      }
    }

    _addToCart(event) {
      let _this = this;

      event.preventDefault();

      /*
       * TEQUILA SUNSET
       *
       * Admitimos tanto:
       * - quick add original/móvil
       * - quick add de tallas en escritorio
       */

      let formElement = this.querySelector(
        'form.ProductQuickAddToCardForm, form.ProductCard__DesktopQuickAddForm'
      );

      let addToCartButton =
        event.target.closest('[data-action="quick-add-to-cart"]');

      if (!addToCartButton) {
        addToCartButton = this.querySelector(
          '.ProductQuickAddToCardForm__AddToCart, .ProductCard__DesktopSizeButton, .ProductCard__DesktopGenericButton'
        );
      }

      /*
       * Seguridad:
       * si por cualquier motivo no encontramos
       * formulario o botón, no continuamos.
       */
      if (!formElement || !addToCartButton) {
        return;
      }

      addToCartButton.setAttribute(
        'disabled',
        'disabled'
      );

      document.dispatchEvent(
        new CustomEvent('theme:loading:start')
      );

      fetch(window.routes.cartAddUrl + '.js', {
        body: JSON.stringify(
          themegoal.components.Form.serialize(
            formElement
          )
        ),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(function (response) {
          document.dispatchEvent(
            new CustomEvent('theme:loading:end')
          );

          if (response.ok) {
            if (window.theme.cartType == 'page') {
              window.location.href =
                window.routes.cartUrl;
            } else {
              addToCartButton.removeAttribute(
                'disabled'
              );

              response.json().then(function (data) {
                let quantityInput =
                  formElement.querySelector(
                    '[name="quantity"]'
                  );

                let quantity =
                  quantityInput
                    ? parseInt(quantityInput.value)
                    : 1;

                _this.dispatchEvent(
                  new CustomEvent('product:added', {
                    bubbles: true,
                    detail: {
                      variant:
                        _this.currentVariant,
                      quantity: quantity,
                      cartItemKey: data.key
                    }
                  })
                );
              });
            }
          } else {
            response.json().then(function (content) {
              var errorMessageElement =
                document.createElement('div');

              errorMessageElement.className =
                'Alert Alert--danger';

              if (
                typeof content['description'] ===
                'object'
              ) {
                errorMessageElement.innerHTML =
                  content['message'];
              } else {
                errorMessageElement.innerHTML =
                  content['description'];
              }

              addToCartButton.removeAttribute(
                'disabled'
              );

              addToCartButton.insertAdjacentElement(
                'beforeBegin',
                errorMessageElement
              );

              setTimeout(function () {
                errorMessageElement.remove();
              }, 8000);
            });
          }
        })
        .catch(function () {
          /*
           * Si falla la petición,
           * restauramos el botón.
           */
          document.dispatchEvent(
            new CustomEvent('theme:loading:end')
          );

          addToCartButton.removeAttribute(
            'disabled'
          );
        });

      event.preventDefault();
    }
  }

  customElements.define(
    'quick-add-to-cart-button',
    TG_QuickAddToCartButton
  );
}